/** Advisory frames have no save, replay queue, or PHP fallback. */
export type EphemeralTruth = Record<string, unknown> & { type: string; actor_id: string; encounter_id: string; operation_id: string };
declare global {
  interface Window { ftPushEphemeralTruth?: (frame: EphemeralTruth) => boolean }
}
export function pushEphemeralTruth(frame: EphemeralTruth): boolean {
  try {
    // The scene can borrow its host's socket without importing another bundle's state.
    const host = window.parent !== window && window.parent.ftPushEphemeralTruth ? window.parent : window;
    return host.ftPushEphemeralTruth?.(frame) === true;
  } catch { return false; }
}
